import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=2a01671b&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a01671b')) {
      api.createRecord('2a01671b', component.options)
    } else {
      api.reload('2a01671b', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=2a01671b&", function () {
      api.rerender('2a01671b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8XmkZ48qQWwBr/JS/comp/childrenage.vue"
export default component.exports